import { useState } from 'react';

import TextField from './TextField.jsx';

// Password field with the mobile app's Show / Hide toggle (app/src/components/
// common/Password.js): a plain-text control inside the field's right edge, in the
// brand accent, that flips the entered text between masked and visible. It is a
// TextField, so it carries the same hidden label / placeholder / error wiring; the
// toggle only changes how the text is displayed, never the value, so it stays
// usable while the field itself is read-only or disabled (e.g. mid sign-in).
//
// Accessibility: the visible text is the app's terse "Show" / "Hide"; a visually
// hidden " password" completes the accessible name ("Show password"), which keeps
// the visible label inside the spoken one (WCAG 2.5.3) and says what the control
// acts on. Visible text rather than aria-label also keeps the field the only
// element labelled "Password" for label-based lookups.
export default function PasswordField({
  id,
  label = 'Password',
  className = '',
  ...props
}) {
  const [visible, setVisible] = useState(false);

  return (
    <TextField
      id={id}
      label={label}
      type={visible ? 'text' : 'password'}
      className={`password-field ${className}`.trim()}
      adornment={
        <button
          type="button"
          className="password-field__toggle"
          aria-controls={id}
          onClick={() => setVisible((shown) => !shown)}
        >
          {visible ? 'Hide' : 'Show'}
          <span className="visually-hidden"> password</span>
        </button>
      }
      {...props}
    />
  );
}
